import {
  ValidationRepository
} from '@private/modules/cash-out-payment/core/repositories/validation/validation.repository';
import { Injectable } from '@angular/core';
import { ApiService } from '@nequi/design-system-lib/logic';
import { ValidationRequestEntity, ValidationResponseEntity } from '@private/modules/cash-out-payment/core/entities';
import { ApiHeaderGenerateService } from '@shared/services/api-header-generate/api-header-generate.service';

@Injectable()
export class ValidationImplRepository implements ValidationRepository {

  constructor(private readonly apiService: ApiService,
              private readonly apiHeaderGenerateService: ApiHeaderGenerateService) {
  }

  public async validate(params: ValidationRequestEntity): Promise<ValidationResponseEntity> {
    const headers = this.apiHeaderGenerateService.generateAuthHeaders();
    return await this.apiService.post<ValidationResponseEntity>('cashout/validation', params, { headers });
  }

}
